<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'NoData',
})
</script>
<template>
  <div class="no_data">
    <img class="n_img" src="@/assets/images/score/noData.png" />
    <div class="n_text">{{ lang('暂无数据') }}</div>
  </div>
</template>
<script setup lang="ts" name="NoData">
import lang from '@/langs'
</script>

<style scoped lang="less">
.no_data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 0;
  .n_img {
    width: 100%;
  }
  .n_text {
    font-size: 14px;
    color: #999999;
  }
}
</style>
